import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import StringRen from "csi/heading/String";
import TextWithMaterialIcon from "csi/widget/TextWithMaterialIcon";
import declare from "dojo/_base/declare";
import { getIconParameters, isLockedAndStarted } from "./ProofService";

const TaskStageNameRenderer = declare(StringRen, {

	/**
	 * @override
	 * Add icon after text
	 */
	toHtmlStatic(ctx: Context, h: Heading, refNode: Element, _params) {
		const value = this._getValue(ctx, h);
		const stageNode = ctx.getNode(); 
		// Do not render if value is not yet defined
		if (!value) {
			return true;
		}

		if (isLockedAndStarted(stageNode)) {
			new TextWithMaterialIcon(getIconParameters("Locked", false, false, value))
				.placeAt(refNode);
			return true;
		}

		return this.inherited(arguments);
	},
});

export = TaskStageNameRenderer;